import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-interbranch-invoicing',
  templateUrl: './interbranch-invoicing.component.html',
  styleUrls: ['./interbranch-invoicing.component.css']
})
export class InterbranchInvoicingComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public grid?: GridOptions;

    public retrieving = false;

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(794))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.setting?.view_id).setLoadDataFunction({ method: this.setting?.p2_datatask_keyno, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async retrieveChanges() {
        if (!!this.setting) {
            try {
                this.retrieving = true;

                await this.datatask.Post(795, this.setting);

                this.loadGrid();
            } finally {
                this.retrieving = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no_from':
            case 'businessco_no_to':
            case 'deliverydate_tom':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no_from: string;
    businessco_no_to: string;
    deliverydate_tom: string;
    view_id: string;
    p2_datatask_keyno: number;
}
